export const PLANS_VERTICAL = 'VERTICALE'
export const PLANS_HORIZONTAL = 'ORIZZONTALE'
export const PLANS_BLOCKS = 'BLOCCHI'